// Safe stringifier for custom-attribute values rendered inside a cart row.
// Values can be scalars (STR/NUM/DAT/CHP/TGL/RDC/LST), arrays of strings
// (MCH), arrays of objects (UPL/ADG images/addons), or objects (AUD voice
// note blob, Dayjs). Returning a raw object/array as a React child throws
// "Objects are not valid as a React child" and hardstops the POS page.

export function customAttrDisplay(value) {
  if (value === null || value === undefined || value === "" || value === false) return null;
  if (Array.isArray(value)) {
    if (value.length === 0) return null;
    const first = value[0];
    if (first && typeof first === "object") {
      // UPL/IMG uploads have dataUrl + image type
      if (first.dataUrl && first.type?.startsWith("image")) {
        return `${value.length} image${value.length > 1 ? "s" : ""}`;
      }
      return `${value.length} item${value.length > 1 ? "s" : ""}`;
    }
    return value.join(", ");
  }
  if (typeof value === "object") {
    if (value.dataUrl && value.duration != null) return `🎙 ${value.duration}s voice note`;
    if (value.name) return String(value.name);
    if (typeof value.format === "function") return value.format("DD-MM-YYYY");
    return null;
  }
  return String(value);
}
